import { render, staticRenderFns } from "./pression.vue?vue&type=template&id=cc4dac8a&scoped=true"
import script from "./pression.vue?vue&type=script&lang=js"
export * from "./pression.vue?vue&type=script&lang=js"
import style0 from "./pression.vue?vue&type=style&index=0&id=cc4dac8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc4dac8a",
  null
  
)

export default component.exports